import {
  File,
  FileArchive,
  FileAudio,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileVideo,
} from 'lucide-react';

/** Icon for a MIME type / file name. */
export function FileIcon({
  contentType,
  name,
  className,
}: {
  contentType: string;
  name: string;
  className?: string;
}) {
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  const Icon = contentType.startsWith('image/')
    ? FileImage
    : contentType.startsWith('video/')
      ? FileVideo
      : contentType.startsWith('audio/')
        ? FileAudio
        : contentType === 'application/pdf' ||
            ['doc', 'docx', 'txt', 'md', 'rtf', 'odt'].includes(ext)
          ? FileText
          : ['xls', 'xlsx', 'csv', 'ods'].includes(ext)
            ? FileSpreadsheet
            : ['zip', 'rar', '7z', 'gz', 'tar'].includes(ext)
              ? FileArchive
              : ['js', 'ts', 'json', 'html', 'css', 'py', 'sql', 'yml', 'yaml'].includes(ext)
                ? FileCode
                : File;
  return <Icon className={className} />;
}
